import { OrderKeys } from '~src/spacesPlatform/models/OrderKeys';
import { SortOptions } from '~src/spacesPlatform/models/sort/CommonSortOptions';
import { Order } from '~src/spacesPlatform/models/sort/Order';
import { SortOptionsForType } from '~src/spacesPlatform/models/sort/SortOptionDefinitions';
import { createNonDisplayOptionDefinition } from '~src/spacesPlatform/models/sort/SortOptionsHelper';

export const GroupSetSortOptions: SortOptionsForType = {
  defaultOrder: [Order.asc(OrderKeys.name)],
  options: {
    'name': SortOptions.name,
    'domainName': createNonDisplayOptionDefinition('domainName', OrderKeys.domainName),
    'minSiteRole': createNonDisplayOptionDefinition('minSiteRole', OrderKeys.minimumSiteRole),
    'userCount': createNonDisplayOptionDefinition('userCount', OrderKeys.userCount),
    'grantLicenseMode': createNonDisplayOptionDefinition('grantLicenseMode', OrderKeys.grantLicenseMode)
  },
  displaySortDropdown: true
};
